export const GOOGLE_MAPS_DEVELOPMENT_API_KEY =
  'AIzaSyAVrUbh5Tpr9at9vFuju3FE8WUO9BFYS5k';
export const GOOGLE_MAPS_STAGING_API_KEY =
  'AIzaSyC8jVlHVjuiUeU4loHd1v0rSWw9j0saGJw';
export const GOOGLE_MAPS_PRODUCTION_API_KEY =
  'AIzaSyDoCe5HmujyyDN_iV2OjYN9yKTy7ZihG7o';
